import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';

@Component({
  selector: 'app-organization-info-dialog',
  templateUrl: './organization-info-dialog.component.html',
  styleUrls: ['./organization-info-dialog.component.scss'],
})
export class OrganizationInfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<OrganizationInfoDialogComponent>) {}

  public organization: any;
  public organizationLocation: any;

  ngOnInit(): void {
    this.organization = this.data.param.organization;
    this.organizationLocation = this.data.param.organizationLocation;
  }

  formatDate(dateString: string): string {
    if (!dateString || dateString.length !== 6) return 'Data inválida';
    const month = dateString.substring(0, 2);
    const year = dateString.substring(2);
    return `${month}/${year}`;
  }

  getCNPJ(): string {
    const identifiers = this.organization?.identifier || [];
    const cnpjObj = identifiers.find((identifier: any) => identifier.system === 'CNPJ');
    const rawCnpj = cnpjObj?.value;

    if (!rawCnpj || rawCnpj.length !== 14) return 'Não informado';

    return rawCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
